<template>
  <div class="care-plan-card-list-wrapper">
    <div
      class="care-plan-card-list"
      :class="{'plan-compatibility': displayConfig.isPlanCompatible}">
      <div
        v-for="item in planCardList" :key="item.planKeyName"
        class="care-plan-card-outer-wrapper">
        <care-plan-card
          :is-annual-active="isAnnualActive"
          :is-feature-active-map="item.isFeatureActiveMap"
          :plan-key-name="item.planKeyName"
          :plan-price="item.planPrice[priceKeyName]"
          :plan-special-price="item.planSpecialPrice[priceKeyName]"
          :event-video-day="item.featureData.eventVideoDay"
          :continuous-video-day="item.featureData.continuousVideoDay"
          :camera-share-cnt="item.featureData.cameraShareCnt"
          :sleeplog-history-day="item.featureData.sleeplogHistoryDay"
          :snap-cute-cnt="item.featureData.snapCuteCnt"
          :show-tag="item.showTag">
        </care-plan-card>
      </div>
    </div>
  </div>
</template>
<script>
import displayConfig from '../../configs/displayConfig';
import CarePlanCard from './CarePlanCard.vue';

export default {
  name: 'care-plan-card-list',
  components: {
    CarePlanCard,
  },
  props: {
    isAnnualActive: {
      type: Boolean,
      required: true,
    },
    planCardList: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      displayConfig,
    };
  },
  computed: {
    priceKeyName() {
      if (this.isAnnualActive) {
        return 'yr';
      }

      return 'mo';
    },
  },
};
</script>
<style lang="sass" scoped>
.care-plan-card-list-wrapper
  .care-plan-card-list
    display: flex
    padding-top: 40px
    &.plan-compatibility
      width: 80vw
    .care-plan-card-outer-wrapper
      margin: 0 28px

@media screen and (min-width: 1600px)
  .care-plan-card-list-wrapper
    .care-plan-card-list
      .care-plan-card-outer-wrapper
        margin: 0 40px

</style>
